/* KH extras for the bundle builder:
   1. Injects the "Not sure which size?" accordion under the locked step-1
      size picker (template rendered by blocks/bundle-builder.liquid).
   2. Shows/hides the accelerated-checkout (Shop Pay / Apple Pay / Google Pay)
      button under the bundle CTA and keeps its variant input synced to the
      size selected in step 1, so wallets can never buy the wrong size.
   Loaded after bundle-builder.js; patches instances non-invasively. */
(function () {
  function enhance(root, inst) {
    // 1. Size accordion under the locked first step
    try {
      var tpl = root.querySelector("[data-bundle-size-accordion]");
      var locked = root.querySelector(".bb-locked");
      if (tpl && tpl.content && locked && !locked.querySelector(".bb-size-accordion")) {
        locked.appendChild(tpl.content.cloneNode(true));
      }
    } catch (e) {}
    // 2. Express checkout sync
    try {
      var box = root.querySelector("[data-bundle-express]");
      if (box) {
        var input = box.querySelector("[data-bundle-express-variant]");
        var slot0 = inst && inst.state && inst.state.bundle && inst.state.bundle[0];
        var cur = inst && inst.currentProduct;
        if (slot0 && cur && slot0.productId === cur.productId) {
          if (input) input.value = String(slot0.variantId);
          box.hidden = false;
        } else {
          box.hidden = true;
        }
      }
    } catch (e) {}
  }

  function patch(root) {
    var inst = root.__bundleBuilder;
    if (!inst || inst.__khPatched) return !!inst;
    inst.__khPatched = true;
    var origRender = inst.render.bind(inst);
    inst.render = function () {
      origRender();
      enhance(root, inst);
    };
    enhance(root, inst);
    return true;
  }

  function attempt(tries) {
    var pending = false;
    document.querySelectorAll("[data-bundle-builder]").forEach(function (r) {
      if (!patch(r)) pending = true;
    });
    if (pending && tries > 0) {
      setTimeout(function () { attempt(tries - 1); }, 100);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { attempt(50); });
  } else {
    attempt(50);
  }
  document.addEventListener("shopify:section:load", function () { attempt(50); });
})();
